import React, { useEffect, useState } from "react";
import styles from "./HeaderComponent.module.scss";
import Logo from "../UI/Logo/Logo";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import {
  selectIsAuthenticated,
  selectIsAdmin,
  selectIsPharmacist,
  selectActiveLicense,
} from "../../store/auth-slice";
import HeaderMenu from "./HeaderMenu/HeaderMenu";
import PharmacistInfo from "./PharmacistInfo/PharmacistInfo";
import { useLocation, useNavigate } from "react-router-dom";
import { pingActiveStatus } from "../../store/auth-actions";

const HeaderComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const marketplaceInfo = useSelector(
    (state: RootState) => state.auth.marketplaceInfo
  );
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isAdmin = useSelector(selectIsAdmin);
  const isPharmacist = useSelector(selectIsPharmacist);
  const activeLicense = useSelector(selectActiveLicense);

  // Derived from Redux selectors - regular marketplace user
  const isCnCUser = isAuthenticated && !isAdmin && !isPharmacist;
  const [RFZOMenuOpen, setRFZOMenuOpen] = useState(false);

  // Status monitoring - redirect to profile when inactive
  useEffect(() => {
    if (marketplaceInfo && marketplaceInfo.takesOrders !== 1) {
      navigate("/profile");
    }
  }, [marketplaceInfo, navigate]);

  // Keep-alive ping for marketplace users - moved from OrderProcessingPage
  useEffect(() => {
    if (isCnCUser && marketplaceInfo && marketplaceInfo.takesOrders === 1) {
      const interval = setInterval(() => {
        dispatch(
          pingActiveStatus(
            marketplaceInfo.branchMarketplaceId,
            marketplaceInfo.marketplaceId
          ) as any
        );
      }, 120000); // 2 minutes

      return () => clearInterval(interval);
    }
  }, [dispatch, isCnCUser, marketplaceInfo]);

  // User type determination now handled by computed value above

  const location = useLocation();
  const linkMapping = {
    profile: "Profil",
    "order-processing": "Pregled porudžbina",
    "admin-marketplace": "Pregled apoteka",
    transactions: "Transakcije",
    statistics: "Statistika",
    "rfzo-reminders": "Podsetnici",
    patients: "Omiljena apoteka",
  };
  const currentLink: string =
    location.pathname.replace("/", "") || "order-processing";
  const textToShow: any =
    linkMapping[currentLink as keyof typeof linkMapping] || "";

  const toggleRFZOMenu = () => {
    setRFZOMenuOpen(!RFZOMenuOpen);
  };

  return (
    <div className={styles.Header}>
      <Logo />
      <div className={styles.ActionsWrapper}>
        {/* Show pharmacist info for CnC users when a pharmacist is active */}
        {isCnCUser && activeLicense && <PharmacistInfo />}

        {isCnCUser && (
          <div
            onClick={toggleRFZOMenu}
            className={styles.RFZOMenu}
            style={{
              backgroundColor: RFZOMenuOpen ? "#DEDFE1" : "inherit",
            }}
          >
            <span>{textToShow}</span>
            {RFZOMenuOpen && <HeaderMenu />}
          </div>
        )}
        {/* UserIcon removed - functionality now in HeaderMenu */}
      </div>
    </div>
  );
};

export default HeaderComponent;
